import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../../../configs/axios/axios ";
import { RootState } from "../../../../../app/store";
import {
  CREATE_FOLDER,
  DELETE_FOLDER,
} from "../../../../../configs/axios/constantsAPI";
import {
  getDirectoryAction,
  searchDirectoryAction,
} from "../../directory/directorySlice";
import { getCookie } from "../../../../../configs/cookie-helper/cookieHelper";
import { getAlternativeFileAction } from "../../drawer/drawer-item/drawer-share/alternative-file-modal/alternativeFileModalSlice";

export const createFolderAction = createAsyncThunk(
  "createFolder/createFolder",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        CREATE_FOLDER,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getDirectoryAction({
          path: getState().directoryState.directoryData.path,
          idfolder: getState().directoryState.directoryData.idfolder,
        })
      );
      dispatch(getAlternativeFileAction());

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteFolderAction = createAsyncThunk(
  "createFolder/deleteFolder",
  async (sendData: any, { dispatch, rejectWithValue, getState }: any) => {
    let token = getCookie("token") as string;
    try {
      const { data } = await axiosInstance.post(
        DELETE_FOLDER,
        JSON.stringify(sendData),
        {
          headers: {
            token: token ? token : getState().authenticationState.token,
          },
        }
      );

      dispatch(
        getDirectoryAction({
          path: getState().directoryState.directoryData.path,
          idfolder: getState().directoryState.directoryData.idfolder,
        })
      );

      if (getState().directoryState.searchInput !== "") {
        dispatch(
          searchDirectoryAction({
            path: getState().directoryState.directoryData.path,
            name: getState().directoryState.searchInput,
            dir: "true",
          })
        );
      }

      return data;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

export interface CreateFolderState {
  openModal: boolean;
}

const initialState: CreateFolderState = {
  openModal: false,
};

export const createFolderSlice = createSlice({
  name: "createFolder",
  initialState,
  reducers: {
    createFolderOpenAction: (state) => {
      state.openModal = true;
    },
    createFolderCloseAction: (state) => {
      state.openModal = false;
    },
  },
});

export const { createFolderOpenAction, createFolderCloseAction } =
  createFolderSlice.actions;

export const createFolder = (state: RootState) => state.createFolderState;

export default createFolderSlice.reducer;
